import { render, staticRenderFns } from "./NomEditAdresaLivrare.vue?vue&type=template&id=88c9dd1c&scoped=true&"
import script from "./NomEditAdresaLivrare.ts?vue&type=script&lang=ts&"
export * from "./NomEditAdresaLivrare.ts?vue&type=script&lang=ts&"
import style0 from "./NomEditAdresaLivrare.vue?vue&type=style&index=0&id=88c9dd1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c9dd1c",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QForm,QInput,QSelect,QBtn});
